import React, { useState } from "react";
import "./ContactSection2.css";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";

export default function ContactSection2() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [isSending, setIsSending] = useState(false);

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSending) {
      return;
    }

    if (!captchaValue) {
      alert("יש לאמת שאתה לא רובוט 🤖");
      return;
    }

    setIsSending(true);

    emailjs
      .send(
        "service_udygc8r",
        "template_6fuh7lc",
        {
          name: formData.name,
          phone: formData.phone,
        },
        "user_7XjWzaNdKiGR2BG0wBiLt"
      )
      .then(
        () => {
          alert("ההודעה נשלחה בהצלחה, נחזור בהקדם האפשרי 👍");

          setFormData({
            name: "",
            phone: "",
          });

          setCaptchaValue(null);
          setIsSending(false);
        },
        (error) => {
          console.log(error);

          alert("ההודעה לא נשלחה, נסה שנית");

          setIsSending(false);
        }
      );
  };

  return (
    <div className="form-box">
      <h3>
        לקבלת ייעוץ ראשוני, מלא פרטים ונשוב אליכם בהקדם
      </h3>

      <form onSubmit={handleSubmit} className="form">
        <input
          type="text"
          name="name"
          placeholder="שם מלא"
          value={formData.name}
          onChange={handleChange}
          disabled={isSending}
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="טלפון"
          value={formData.phone}
          onChange={handleChange}
          disabled={isSending}
          required
        />

        <button type="submit" disabled={isSending}>
          {isSending ? (
            <>
              <span className="contact-spinner"></span>
              שולח...
            </>
          ) : (
            "שליחה"
          )}
        </button>
      </form>

      <div className={isSending ? "captcha-disabled" : ""}>
        <ReCAPTCHA
          sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
          onChange={handleCaptchaChange}
        />
      </div>
    </div>
  );
}

